import { CommonModule } from '@angular/common';
import {
  ApplicationRef,
  Component,
  ElementRef,
  inject,
  Input,
  OnInit,
  Renderer2,
  TemplateRef,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'app-custom-cona-tooltip',
  templateUrl: './custom-cona-tooltip.component.html',
  styleUrls: ['./custom-cona-tooltip.component.css'],
  standalone: true,
  imports: [CommonModule],
})
export class CustomConaTooltipComponent implements OnInit {
  @Input() text: string = '';
  @Input() position: 'top' | 'bottom' | 'left' | 'right' | 'left-center' | 'top-right' = 'top';
  @Input() bgColor: 'white' | 'red' | 'black' = 'black';

  @ViewChild('toolTipContainerRef', { static: true })
  toolTipContainerRef!: ElementRef<HTMLDivElement>;

  @ViewChild('tooltipTemplate', { static: true })
  tooltipTemplateRef!: TemplateRef<any>;

  private tooltipViewRef: any;
  private tooltipElement!: HTMLElement;

  private applicationRef = inject(ApplicationRef);
  private renderer = inject(Renderer2);

  constructor() {}

  ngOnInit() {}

  showTooltip() {
    if (this.tooltipViewRef) return; //to avoid duplicates

    // Create view from template
    this.tooltipViewRef = this.tooltipTemplateRef.createEmbeddedView({});
    this.applicationRef.attachView(this.tooltipViewRef);
    this.tooltipElement = this.tooltipViewRef.rootNodes[0] as HTMLElement;

    // Apply temporary styles to measure
    this.renderer.setStyle(this.tooltipElement, 'position', 'absolute');
    this.renderer.setStyle(this.tooltipElement, 'visibility', 'hidden');
    this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'none');

    // Append to body
    document.body.appendChild(this.tooltipElement);

    // Wait for DOM to apply styles and render the element
    requestAnimationFrame(() => {
      const viewportWidth = window.innerWidth;
      const containerRectangle = this.toolTipContainerRef.nativeElement.getBoundingClientRect();
      const tooltipRectangle = this.tooltipElement.getBoundingClientRect();

      let top = 0,
        left,
        right = 0;

      switch (this.position) {
        case 'left-center':
          top = containerRectangle.top + containerRectangle.height / 2 - tooltipRectangle.height / 2;
          left = containerRectangle.left - tooltipRectangle.width - 8;
          this.renderer.setStyle(this.tooltipElement, 'left', `${left}px`);
          break;

        case 'top-right':
          top = containerRectangle.top - tooltipRectangle.height - 8;
          right = viewportWidth - containerRectangle.x - (containerRectangle.width / 2 + 20);
          this.renderer.setStyle(this.tooltipElement, 'right', `${right}px`);
          break;
      }

      // Apply final styles
      this.renderer.setStyle(this.tooltipElement, 'top', `${top}px`);
      this.renderer.setStyle(this.tooltipElement, 'visibility', 'visible');
      this.renderer.setStyle(this.tooltipElement, 'pointer-events', 'auto');
    });
  }

  hideTooltip() {
    if (this.tooltipViewRef) {
      this.applicationRef.detachView(this.tooltipViewRef);
      this.tooltipViewRef.destroy();
      this.tooltipViewRef = null;
    }
    if (this.tooltipElement && this.tooltipElement.parentElement) {
      this.tooltipElement.parentElement.removeChild(this.tooltipElement);
    }
  }
}
